import {
    FETCH_AUDIT_EVENTS,
    FETCH_AUDIT_EVENTS_FAIL,
    FETCH_AUDIT_EVENTS_SUCCESS,
    FETCH_AUDIT_USERS_SUCCESS
} from './actionTypes';
import {
    defaultFirstPage,
    defaultItemsPerPage
} from '../../../../services/Paging';

export const initialState = {
    data: [],
    pagination: {
        pageSize: defaultItemsPerPage,
        page: defaultFirstPage,
        hasNextPage: false
    },
    // What the events are of: a jurisdiction (or a sandbox) and a type of event; the newest first
    filters: { jurisdiction: '', eventType: '' },
    sort: { sortType: 'EVENT_TIMESTAMP', sortOrder: 'DESC' },
    // The admins that events can name: [{ id, firstName, lastName, ... }]
    users: [],
    error: null,
    loading: false,
    loaded: false
};

export function auditReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_AUDIT_EVENTS: {
            const {
                page,
                pageSize,
                sortType,
                sortOrder,
                jurisdiction,
                eventType
            } = action.payload;

            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    page: page || state.pagination.page,
                    pageSize: pageSize || state.pagination.pageSize
                },
                filters: {
                    jurisdiction:
                        jurisdiction === undefined
                            ? state.filters.jurisdiction
                            : jurisdiction,
                    eventType:
                        eventType === undefined
                            ? state.filters.eventType
                            : eventType
                },
                sort: {
                    sortType: sortType || state.sort.sortType,
                    sortOrder: sortOrder || state.sort.sortOrder
                },
                loading: true
            };
        }
        case FETCH_AUDIT_EVENTS_SUCCESS:
            return {
                ...state,
                data: action.payload.result || [],
                pagination: {
                    ...state.pagination,
                    hasNextPage: !!action.payload.hasNext
                },
                error: null,
                loading: false,
                loaded: true
            };
        case FETCH_AUDIT_EVENTS_FAIL:
            return { ...state, error: action.payload, loading: false };
        case FETCH_AUDIT_USERS_SUCCESS:
            return { ...state, users: action.payload || [] };
        default:
            return state;
    }
}
